/* Clear-cart control for the Rebuy Smart Cart.
   A discreet "Clear cart" text link under the cart's line items with a two-tap confirm
   (so nobody empties their cart by accident). Empties via /cart/clear.js, then
   re-renders the Smart Cart in place via Rebuy.SmartCart.setCart() (no full page
   reload). Falls back to a soft reload only if Rebuy isn't available. */
(function () {
  'use strict';

  function emptyCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var SC = window.Rebuy && window.Rebuy.SmartCart;
        var rendered = false;
        try {
          if (SC && typeof SC.setCart === 'function') { SC.setCart(cart); rendered = true; }
          if (SC && typeof SC.updateCartCount === 'function') SC.updateCartCount();
          if (SC && typeof SC.updateCartSubtotal === 'function') SC.updateCartSubtotal();
        } catch (e) { rendered = false; }
        ['rebuy:cart:updated', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
          try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
        });
        // If we couldn't drive Rebuy's re-render, fall back to a soft reload so the
        // emptied cart is never shown stale.
        if (!rendered) setTimeout(function () { window.location.reload(); }, 150);
      });
  }

  function makeLink() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kv-clear-cart';
    btn.textContent = 'Clear cart';
    var armed = false, t = null;
    function reset() { armed = false; btn.classList.remove('is-armed'); btn.textContent = 'Clear cart'; btn.disabled = false; }
    btn.addEventListener('click', function () {
      if (!armed) { armed = true; btn.classList.add('is-armed'); btn.textContent = 'Tap again to clear'; clearTimeout(t); t = setTimeout(reset, 3000); return; }
      clearTimeout(t); btn.textContent = 'Clearing…'; btn.disabled = true;
      emptyCart().then(reset).catch(reset);
    });
    return btn;
  }

  // Right after the line items (Aman, 20 Oct: keep it, in a different place than the header). Rebuy renders the items
  // block even for an empty cart, so the link always goes in; kv-cart-direction.css hides it while there are no items.
  // If a Rebuy re-render moves it, the next cart event puts it back.
  function inject() {
    var items = document.querySelector('#rebuy-cart [data-rebuy-component="cart-items"]');
    if (!items) return;
    var btn = document.querySelector('.kv-clear-cart');
    if (btn && btn.previousElementSibling === items) return;
    items.insertAdjacentElement('afterend', btn || makeLink());
  }

  var iv = setInterval(inject, 700);
  setTimeout(function () { clearInterval(iv); }, 30000);
  ['rebuy:smartcart.show', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (ev) { document.addEventListener(ev, inject); });
})();
